import(/* webpackMode: "eager", webpackExports: ["MDXContent"] */ "/vercel/path0/website/components/docs/mdx-content.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/website/node_modules/next/dist/client/link.js");
